// Mobile Grid Toggle Functionality
document.addEventListener('DOMContentLoaded', () => {
  const mobileToggle = document.getElementById('mobile-grid-toggle');
  const productGrid = document.getElementById('product-grid');
  const toggleButtons = document.querySelectorAll('.mobile-grid-toggle__button');

  function setGridColumns(columns) {
    // Update active state
    toggleButtons.forEach((btn) => {
      btn.classList.remove('mobile-grid-toggle__button--active');
      if (btn.dataset.columns === columns) {
        btn.classList.add('mobile-grid-toggle__button--active');
      }
    });

    // Apply grid layout via data attribute
    if (productGrid) {
      productGrid.setAttribute('data-mobile-columns', columns);
    }
  }

  if (mobileToggle && productGrid) {
    // Set default state from localStorage or default to 1 column
    const savedColumns = localStorage.getItem('mobile-grid-columns') || '1';
    setGridColumns(savedColumns);

    // Remove the preload style to show the grid (mobile only)
    const preloadStyle = document.getElementById('grid-preload');
    if (preloadStyle) {
      preloadStyle.remove();
    }

    // Handle toggle button clicks
    toggleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const { columns } = button.dataset;
        setGridColumns(columns);
        localStorage.setItem('mobile-grid-columns', columns);
      });
    });
  }
});
